import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsUpRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.96.16h12.88v12.88l-3.36-3.376l-6.16 6.176L.16 9.68l6.16-6.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsUpRight
